export enum PatientCaseType {
  PRESCRIPTION_REFILL = "prescription_refill",
}
